"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.envConfig = void 0;
var envConfig = {
  DEVELOPMENT: {
    redirectionURL: 'https://www.devairasia.com/hotel/search',
    snapBannerURL: 'https://a.staticaa.com/images/snap/SNAP_APP_BANNER_PNG.png',
    chinaRedirectionURL: 'https://www.airasia.cn/hotel/search',
    GCS_URL: 'https://ppsch.apiairasia.com',
    FEATURE_FLAG_ENV: 'dev',
    placePickerConfig: {
      ssr_url: 'https://hotels.dev-apiairasia.com/hotelsa/getssrdata',
      suggestions_url: 'https://hotels.dev-apiairasia.com/smartfill/v2/smartfill?language={0}&query={1}',
      client_id: 'e1198278-24ca-4962-82ca-5153b442ccf5',
      suggestion_url: 'https://hotels.dev-apiairasia.com/smartfill/v2/smartfill/{0}?language={1}'
    },
    STATIC_URL: 'https://static.stgairasia.com'
  },
  STAGING: {
    redirectionURL: 'https://www.stgairasia.com/hotel/search',
    snapBannerURL: 'https://a.staticaa.com/images/snap/SNAP_APP_BANNER_PNG.png',
    chinaRedirectionURL: 'https://www.airasia.cn/hotel/search',
    placePickerConfig: {
      ssr_url: 'https://hotels.stg-apiairasia.com/hotelsa/getssrdata',
      suggestions_url: 'https://hotels.stg-apiairasia.com/smartfill/v2/smartfill?language={0}&query={1}',
      client_id: 'b0d1ad95-41db-4399-a6df-248ff8834278',
      suggestion_url: 'https://hotels.stg-apiairasia.com/smartfill/v2/smartfill/{0}?language={1}'
    },
    GCS_URL: 'https://ppsch.apiairasia.com',
    FEATURE_FLAG_ENV: 'staging',
    STATIC_URL: 'https://static.stgairasia.com'
  },
  PRE_PRODUCTION: {
    redirectionURL: 'https://www.stgairasia.com/hotel/search',
    snapBannerURL: 'https://a.staticaa.com/images/snap/SNAP_APP_BANNER_PNG.png',
    chinaRedirectionURL: 'https://www.airasia.cn/hotel/search',
    placePickerConfig: {
      ssr_url: 'https://hotels.stg-apiairasia.com/hotelsa/getssrdata',
      suggestions_url: 'https://hotels.stg-apiairasia.com/smartfill/v2/smartfill?language={0}&query={1}',
      client_id: 'b0d1ad95-41db-4399-a6df-248ff8834278',
      suggestion_url: 'https://hotels.stg-apiairasia.com/smartfill/v2/smartfill/{0}?language={1}'
    },
    GCS_URL: 'https://sch.apiairasia.com',
    FEATURE_FLAG_ENV: 'preprod',
    STATIC_URL: 'https://static.airasia.com'
  },
  PRODUCTION: {
    redirectionURL: 'https://www.airasia.com/hotel/search',
    snapBannerURL: 'https://a.staticaa.com/images/snap/SNAP_APP_BANNER_PNG.png',
    chinaRedirectionURL: 'https://www.airasia.cn/hotel/search',
    placePickerConfig: {
      ssr_url: 'https://hotels.apiairasia.com/hotelsa/getssrdata',
      suggestions_url: 'https://hotelsbe.apiairasia.com/smartfill/v2/smartfill?language={0}&query={1}',
      client_id: '7ed9641f-512f-4564-910f-e6139a08e3f6',
      suggestion_url: 'https://hotelsbe.apiairasia.com/smartfill/v2/smartfill/{0}?language={1}'
    },
    GCS_URL: 'https://sch.apiairasia.com',
    FEATURE_FLAG_ENV: 'production',
    STATIC_URL: 'https://static.airasia.com'
  }
};
exports.envConfig = envConfig;